import React, { useState, useEffect, useRef } from "react"; // Import useRef
import { MdArrowDropDown } from "react-icons/md";
import axios from "axios";
import Constant from "../Components/Utils/Constant";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useNavigate } from "react-router-dom";

export default function CreatePlan({ onClose }) {
  const [isVisible, setIsVisible] = useState(true);
  const [isDropdownOpenfilter, setIsDropdownOpenfilter] = useState(false);
  const [planname, setPlanname] = useState("");
  const [price, setPrice] = useState("");
  const [discount, setDiscount] = useState("");
  const [planevisibility, setPlanevisibility] = useState([]);
  const [planevalidity, setPlanevalidity] = useState("");
  const [validityUnit, setValidityUnit] = useState("days");
  const [subscription, setSubscription] = useState([]);
  const [totalCount1, setTotalCount1] = useState(null);
  const [selectAllChecked, setSelectAllChecked] = useState(false);
  const navigate = useNavigate();

  // NEW: Create a ref for the dropdown container
  const dropdownRef = useRef(null);

  const dropdownOptions = [
    { id: 1, planname: "Super Admin" },
    { id: 2, planname: "Admin" },
    { id: 3, planname: "Affiliate" },
    { id: 4, planname: "User" },
  ];

  const initialCheckboxStates = {
    1: true,
    2: true,
    3: false,
    4: false,
  };

  const [checkboxStates, setCheckboxStates] = useState(initialCheckboxStates);

  const handleCheckboxChanged = (id) => {
    setCheckboxStates({
      ...checkboxStates,
      [id]: !checkboxStates[id],
    });
  };

  useEffect(() => {
    const updatedCuponassign = Object.keys(checkboxStates)
      .filter((key) => checkboxStates[key])
      .map((key) => {
        const option = dropdownOptions.find(
          (option) => option.id === parseInt(key)
        );
        return option ? option.planname : null;
      })
      .filter((name) => name !== null);
    setPlanevisibility(updatedCuponassign);
  }, [checkboxStates]);

  const handleSelectAllChanged = () => {
    const allChecked = !selectAllChecked;
    const newCheckboxStates = {};
    dropdownOptions.forEach((option) => {
      newCheckboxStates[option.id] = allChecked;
    });
    setCheckboxStates(newCheckboxStates);
    setSelectAllChecked(allChecked);
  };

  const handleClose = () => {
    setIsVisible(false);
    onClose();
  };

  const toggleDropdownfilter = () => {
    setIsDropdownOpenfilter(!isDropdownOpenfilter);
  };

  const fetchSubscription = async () => {
    try {
      const response = await fetch(`${Constant.BASE_URL}/subscription/get`);
      const data = await response.json();

      if (data && data.subscription) {
        setSubscription(data.subscription);
        setCheckboxStates(
          Object.fromEntries(data.subscription.map((sub) => [sub.id, false]))
        );
        if (data.success) {
          setTotalCount1(data.totalCount);
        }
      }
    } catch (error) {
      console.error("Error fetching subscription:", error);
    }
  };

  useEffect(() => {
    fetchSubscription();
  }, []);

  // NEW: Add useEffect to handle clicks outside the dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpenfilter(false); // Close the dropdown if click is outside
      }
    };

    // Add event listener to the document
    document.addEventListener("mousedown", handleClickOutside);

    // Clean up the event listener on component unmount
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []); // Empty dependency array ensures this runs only once

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validation: Check if all required fields are filled
    if (!String(planname).trim()) {
      toast.error("Plan name is required");
      return;
    }
    if (!String(price).trim()) {
      toast.error("Price is required");
      return;
    }
    if (!planevalidity) {
      toast.error("Plan validity is required");
      return;
    }
    if (planevisibility.length === 0) {
      toast.error("Please select at least one plan visibility");
      return;
    }

    try {
      const subscriptionData = {
        planname: String(planname).trim(),
        price: String(price).trim(),
        discount,
        planevalidity: Number(planevalidity),
        validityUnit,
        planevisibility,
      };
      
      const response = await axios.post(
        `${Constant.BASE_URL}/subscription/upload`,
        subscriptionData
      );
      
      if (response.status === 201) {
        setPrice("");
        setPlanname("");
        setDiscount("");
        setPlanevalidity("");
        setPlanevisibility([]);
        setCheckboxStates({
          1: true,
          2: true,
          3: false,
          4: false,
        });

        toast.success("Plan created successfully");

        setTimeout(() => {
          handleClose();
        }, 3000);
      } else {
        toast.error("Failed to create plan. Please try again.");
        console.log("Failed to submit form. Status:", response.status);
      }
    } catch (error) {
      console.error("Error creating subscription plan:", error);
      if (error.response?.data?.message) {
        toast.error(error.response.data.message);
      } else {
        toast.error("Error creating subscription plan. Please try again.");
      }
    }
  };

  return isVisible ? (
    <>
      <ToastContainer position="top-right" autoClose={3000} />
      <div className="popup-form">
        <div className="w-full  flex items-center justify-center">
          <div className="bg-white p-4 rounded-md shadow-md  py-3 px-1 lg:py-3 xl:py-3 2xl:p-4  ">
            <div className="lg:w-[250px] xl:w-[290px] 2xl:w-[380px] items-center justify-center">
              <div className="text-lg font-semibold text-center mb-4 2xl:text-4xl ">
                Create Plan
              </div>
              <hr className="mt-1 " />

              <form onSubmit={handleSubmit}>
                <div className="flex flex-col justify-center items-center ">
                  <div className="lg:py-5 xl:py-5 2xl:py-10 lg:text-[10px] xl:text-[13px] 2xl:text-[22px]">
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Plan Name :<span className="text-red-500 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        id="yourInput"
                        className="border-b border-gray-500 outline-none flex items-start mb-2"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="Text"
                        value={planname}
                        onChange={(e) => setPlanname(e.target.value)}
                        required
                      />
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Price (rs.) :
                        <span className="text-red-500 ml-1">*</span>
                      </label>
                      <input
                        type="text"
                        id="price"
                        name="price"
                        className="border-b border-gray-500 outline-none flex items-start mb-2 "
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="Amount"
                        value={price}
                        onChange={(e) => setPrice(e.target.value)}
                        required
                      />
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="discount"
                        className="flex items-end px-3"
                      >
                        Discount :
                      </label>
                      <input
                        type="text"
                        id="discount"
                        name="discount"
                        className="border-b border-gray-500 outline-none flex items-start mb-2"
                        style={{ width: "163px", textAlign: "center" }}
                        placeholder="e.g. 10% or 500"
                        value={discount}
                        onChange={(e) => setDiscount(e.target.value)}
                      />
                    </div>
                    <div className="flex py-3 justify-end items-center">
                      <label
                        htmlFor="yourInput"
                        className="flex items-end px-3"
                      >
                        Plan Validity:
                        <span className="text-red-500 ml-1">*</span>
                      </label>
                      <div className="flex items-center gap-2" style={{ width: '163px' }}>
                        <input
                          type="number"
                          id="planevalidity"
                          name="planevalidity"
                          className="border-b border-gray-500 outline-none flex items-start mb-2"
                          style={{ width: '80px', textAlign: 'center' }}
                          placeholder="e.g. 30"
                          value={planevalidity}
                          onChange={(e) => setPlanevalidity(e.target.value)}
                          min="1"
                          required
                        />
                        <select
                          value={validityUnit}
                          onChange={(e) => setValidityUnit(e.target.value)}
                          className="mb-2 border-b border-gray-500 outline-none bg-white"
                          style={{ width: '75px', textAlign: 'center' }}
                        >
                          <option value="days">Days</option>
                          <option value="hours">Hours</option>
                        </select>
                      </div>
                    </div>
                    <div className="flex justify-end">
                      {/* NEW: Attach the ref to the dropdown's parent div */}
                      <div
                        ref={dropdownRef}
                        className="relative flex items-center justify-start py-3 cursor-pointer mb-8"
                      >
                        <label
                          htmlFor="yourInput"
                          className="flex items-end px-3"
                        >
                          Plan Visibility :
                          <span className="text-red-500 ml-1">*</span>
                        </label>
                        <div className="flex pb-2 border-b border-gray-500 outline-none ">
                          <input
                            type="text"
                            placeholder="Select category"
                            value={planevisibility.join(", ")}
                            readOnly
                            style={{ border: "none", outline: "none" }}
                          />
                          <MdArrowDropDown
                            onClick={toggleDropdownfilter}
                            className="text-xl"
                          />
                          {isDropdownOpenfilter && (
                            <div
                              style={{
                                boxShadow:
                                  "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                                borderRadius: "0 0 5px 5px",
                                zIndex: "100",
                              }}
                              className="lg:text-[10px] xl:w-[163px] lg:w-fit xl:text-[15px] absolute top-12 left-25 bg-white border border-white border-opacity-60 bg-white"
                            >
                              <ul className="overflow-y-auto h-[130px] modelscroll">
                                <li className="border-t px-2 py-1  cursor-pointer text-black flex justify-between items-center">
                                  <span className="text-[12px]">All</span>
                                  <div className="flex justify-end items-center">
                                    <label className="inline-flex items-center">
                                      <div
                                        className={`w-4 h-4 bg-white border border-black-300 shadow-lg  rounded-sm flex items-center justify-center ml-2 ${
                                          selectAllChecked ? "bg-red-500" : ""
                                        }`}
                                      >
                                        {selectAllChecked && (
                                          <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                        )}
                                      </div>
                                      <input
                                        className="hidden"
                                        type="checkbox"
                                        checked={selectAllChecked}
                                        onChange={handleSelectAllChanged}
                                      />
                                    </label>
                                  </div>
                                </li>

                                {dropdownOptions.map((option) => (
                                  <div
                                    key={option.id}
                                    className="border-t px-2 py-1  cursor-pointer text-black flex justify-between items-center"
                                  >
                                    <span className="text-[12px]">
                                      {option.planname}
                                    </span>
                                    <div className="flex items-center">
                                      <label className="inline-flex items-center">
                                        <div
                                          className={`w-4 h-4 bg-white border border-black-300 shadow-lg  rounded-sm flex items-center justify-center ml-2 ${
                                            checkboxStates[option.id] ? "" : ""
                                          }`}
                                        >
                                          {checkboxStates[option.id] && (
                                            <div className="w-2 h-2 bg-gradient-to-r from-yellow-200 to-orange-500"></div>
                                          )}
                                        </div>

                                        <input
                                          className="hidden"
                                          type="checkbox"
                                          checked={checkboxStates[option.id]}
                                          onChange={() =>
                                            handleCheckboxChanged(option.id)
                                          }
                                        />
                                      </label>
                                    </div>
                                  </div>
                                ))}
                              </ul>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    className=" flex justify-center p-1 space-x-12 
                                        lg:text-[10px] xl:text-[13px] 2xl:text-[22px]"
                  >
                    <button
                      type="button"
                      onClick={handleClose}
                      className=" bg-white px-3 py-1 flex-shrink-0 shadow-md rounded-sm"
                      style={{
                        boxShadow: "0px 4px 8px 0px rgba(0, 0, 0, 0.25)",
                      }}
                    >
                      Cancel
                    </button>
                    <button
                      type="submit"
                      className="px-3 py-1 flex-shrink-0 rounded-sm"
                      style={{
                        background:
                          "radial-gradient(125% 125% at 85.42% 0%, #FFD6A6 0%, #FF9C28 100%)",
                      }}
                    >
                      Save
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  ) : null;
}